import { ApplicationUuid, TeamConfiguration } from '@bringg/types';
import { ApplicationMerchantConfigurationStore, MerchantConfigurationsStore } from '@bringg-frontend/global-stores';
import { RoutesPlannerConfiguration } from '@bringg-frontend/routes-planner';
import TeamConfigurationApi from '@bringg/dashboard-sdk/dist/TeamConfiguration/TeamConfigurationApi';

import ApplicationTeamConfigurationStore from 'bringg-web/stores/application-team-configuration/application-team-configuration-store';
import { updateRoutesPlannerConfig } from 'bringg-web/components/routes-planner-modal/routes-planner-data-creator/routes-planner-data-creator';

const getRO2ConfigValue = (
	applicationMerchantConfigurationStore: ApplicationMerchantConfigurationStore,
	applicationTeamConfigurationStore: ApplicationTeamConfigurationStore,
	teamId: number,
	configKey: string
) => {
	const teamConfig = applicationTeamConfigurationStore.getConfigData(ApplicationUuid.RouteOptimizer2, teamId);
	const merchantConfig = applicationMerchantConfigurationStore.getConfiguration(ApplicationUuid.RouteOptimizer2);
	return teamConfig?.[configKey] || merchantConfig?.[configKey];
};

const enrichRoutesPlannerConfig = async (
	config: RoutesPlannerConfiguration,
	applicationMerchantConfigurationStore: ApplicationMerchantConfigurationStore,
	applicationTeamConfigurationStore: ApplicationTeamConfigurationStore,
	merchantConfigurationsStore: MerchantConfigurationsStore,
	teamConfigurationApi: TeamConfigurationApi,
	teamId: number,
	useInitialLoadingTime: boolean
) => {
	config.doSkillsIntersection = getRO2ConfigValue(
		applicationMerchantConfigurationStore,
		applicationTeamConfigurationStore,
		teamId,
		'do_skills_intersection'
	);
	if (useInitialLoadingTime) {
		const teamConfiguration: TeamConfiguration = await teamConfigurationApi.get(teamId);
		config.initialLoadingTimeMinutes =
			teamConfiguration.initial_loading_time_minutes || merchantConfigurationsStore.initialLoadingTimeMinutes;
		config.initialUnloadingTimeMinutes =
			teamConfiguration.initial_unloading_time_minutes || merchantConfigurationsStore.initialUnloadingTimeMinutes;
	}
	config.endOfWeekDay = merchantConfigurationsStore.endOfWeekDay;
	config.kpi = {
		isFairnessEnabled:
			getRO2ConfigValue(
				applicationMerchantConfigurationStore,
				applicationTeamConfigurationStore,
				teamId,
				'penalty_for_drivers_fairness'
			) ||
			getRO2ConfigValue(
				applicationMerchantConfigurationStore,
				applicationTeamConfigurationStore,
				teamId,
				'prefer_fair_solution'
			)
	};
	return await updateRoutesPlannerConfig(config);
};

const loadRO2Config = async (
	baseConfig: RoutesPlannerConfiguration,
	applicationMerchantConfigurationStore: ApplicationMerchantConfigurationStore,
	applicationTeamConfigurationStore: ApplicationTeamConfigurationStore,
	merchantConfigurationStore: MerchantConfigurationsStore,
	teamConfigurationApi: TeamConfigurationApi,
	teamId: number,
	useInitialLoadingTime: boolean
) => {
	await Promise.all([
		applicationMerchantConfigurationStore.fetchConfiguration(ApplicationUuid.RouteOptimizer2),
		applicationTeamConfigurationStore.getConfiguration(ApplicationUuid.RouteOptimizer2, teamId)
	]);

	return await enrichRoutesPlannerConfig(
		baseConfig,
		applicationMerchantConfigurationStore,
		applicationTeamConfigurationStore,
		merchantConfigurationStore,
		teamConfigurationApi,
		teamId,
		useInitialLoadingTime
	);
};

export const RouteOptimizerConfigService = { loadRO2Config };
